import { render, staticRenderFns } from "./ContractStallionList.vue?vue&type=template&id=0eda0c58&"
import script from "./ContractStallionList.vue?vue&type=script&lang=js&"
export * from "./ContractStallionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports